const accessTokenCheck = () => (next) => (action) => {
	next(action);
};

export default accessTokenCheck;
